import { MenuButtonData } from '../system/Classes/MenuButtonData';

export const introMenuData: Array<MenuButtonData> = [
    {display:"校長的話", path:"/intro/principal"},
    {display:"辦學團體", path:"/intro/team"},
    {display:"辦學理念", path:"/intro/concept"},
    {display:"校歌、校徽及校服", path:"/intro/song"},
    {display:"校舍介紹", path:"/intro/school"},
];
